// extracted by mini-css-extract-plugin
export var container = "_7a-0";
export var infoButton = "_7a-1";
export var label = "_7a-3";
export var labelExpanded = "_7a-4";
export var price = "_7a-5";
export var priceExpanded = "_7a-6";
export var title = "_7a-2";